import { lazy } from "react";

export const MyProfile = lazy(() => import("./myProfile/MyProfile"))
export const ChangePassword = lazy(() => import("./changePassword/ChangePassword"))